import { observable, makeObservable } from 'mobx';
import {TimeOffTransaction} from 'main/stores/time_off/index';

class ManualAdjustmentTransaction extends TimeOffTransaction {
  adjustBy = 'days';
  adjustment;

  constructor(other) {
    super();

    makeObservable(this, {
      adjustBy: observable,
      adjustment: observable
    });

    this.merge(other);
  }

  _afterMerge() {
    this.adjustment = this.amount;
  }
}

export default ManualAdjustmentTransaction;
